import React from 'react'

const DownTriangleIcon = (options = {}) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.35537 5.64095C5.1597 5.83864 4.8403 5.83864 4.64463 5.64095L0.646839 1.60173C0.334358 1.28601 0.557999 0.749999 1.00221 0.749999L8.99779 0.75C9.442 0.75 9.66564 1.28601 9.35316 1.60173L5.35537 5.64095Z"
        fill="#494949"
      />
    </svg>
  )
}

export default DownTriangleIcon
